module.exports = __webpack_public_path__ + "static/Group8-81445036a9d509a0eca4920bf2bacccf.png";